import React from 'react';

export default function SectionHeader({ title, subtitle, centered = true, dark = false }) {
  return (
    <div className={`mb-16 ${centered ? 'text-center' : 'text-left'}`}>
      <span className={`uppercase tracking-[0.3em] text-xs font-bold mb-4 block ${dark ? 'text-teal-400' : 'text-teal-700'}`}>
        {subtitle}
      </span>
      <h2 className={`text-3xl md:text-5xl font-light tracking-tight leading-tight ${dark ? 'text-white' : 'text-stone-900'}`}>
        {title}
      </h2>
    </div>
  );
}